<template>
  <div name="modality-inputs-results">
    <div class="modality-inputs">
      <b-row>
        <!-- ICONE DE FECHAR -->
        <b-col class="remove-col" cols="12">
          <button class="remove-col--btn" @click="$emit('closeInputs', $event)">
            <Icon icon="x-icon" />
          </button>
        </b-col>
      </b-row>

      <div class="form--row form--row__nowrap">
        <!-- SELECT DE TIPO DE PAGAMENTO -->
        <PmwFormSelect
          v-model="paymentType"
          :options="paymentOptionsFiltered"
          :search="true"
          :infoIcon="true"
          infoText="Define se o hóspede vai pagar pela hospedagem no ato da reserva, ou se os seus dados são utilizados apenas como forma de garantia."
          label="Tipo de pagamento"
          placeholder="Selecione"
          class="form--input-select form--input__large"
        />

        <!-- SELECT DE COBRANÇA -->
        <PmwFormSelect
          v-model="chargeType"
          :disabled="disableCharge"
          :options="chargeOptions"
          :search="true"
          :infoIcon="true"
          infoText="Define o que será cobrado, de acordo com o tipo de pagamento."
          label="Cobrança"
          placeholder="Selecione"
          class="form--input-select form--input__medium"
        />

        <!-- INPUT DE PERCENTUAL -->
        <PmwFormInput
          v-model.number="percentage"
          :disabled="disablePercentage"
          :infoIcon="true"
          infoText="O percentual informado aqui será cobrado no ato de reserva e o restante ficará pendente para ser pago no hotel."
          label="Percentual"
          type="number"
          placeholder="100"
          max="99"
          min="0"
          sufix="%"
          class="form--input-normal form--input__small"
        />

        <!-- INPUT DE POLITICA DE REEMBOLSO -->
        <PmwFormSelect
          v-model="refund"
          :disabled="disableRefund"
          :options="refundOptions"
          :search="true"
          :infoIcon="true"
          infoText="Define se o pagamento efetuado pelo hóspede pode ou não ser reembolsado."
          label="Política de reembolso"
          placeholder="Selecione"
          class="form--input-select form--input__large"
        />

        <!-- INPUT DE LIMITE DE REEMBOLSO -->
        <PmwFormInput
          v-model.number="refundTimeLimit"
          :disabled="disableRefundLimit"
          :error="showRefundError"
          :infoIcon="true"
          :required="refund?.value === 1"
          infoText="Define que, depois de atingido o limite de horas especifico aqui, a tarifa deixa de ser reembolsável."
          label="Limite para reembolso"
          type="number"
          min="1"
          max="9999"
          placeholder="00"
          class="form--input-normal form--input__large"
        />

        <!-- BOTÃO DE ADICIONAR VALORES SELECIONADOS -->
        <PmwButton
          :disabled="disableAddButton"
          variation="blue-100"
          class="form--button"
          @click="addChargeTypeHandler"
        >
          Adicionar
        </PmwButton>
      </div>
    </div>

    <div
      v-for="item in fluctuationData.meiosPagamento"
      :key="`payment-type-${item.tipoPagamento}`"
      class="modality-results"
    >
      <b-row>
        <!-- TITULO DOS VALORES SELECIONADOS -->
        <b-col cols="11">
          <PmwHeading
            size="paragraph-60"
            weight="weight-normal"
            class="form--title__bold"
          >
            {{
              paymentOptions.find(
                (payOption) => +payOption.value === +item.tipoPagamento
              )?.text
            }}
          </PmwHeading>
        </b-col>

        <!-- ICONE DE FECHAR -->
        <b-col class="remove-col" cols="1">
          <button
            class="remove-col--btn"
            @click="deleteChargeType(item.tipoPagamento)"
          >
            <Icon icon="x-icon" />
          </button>
        </b-col>
      </b-row>

      <!-- TIPO DE COBRANÇA -->
      <div class="form--row form--row__margin">
        <PmwHeading
          size="paragraph-60"
          weight="weight-normal"
          class="form--item"
        >
          <b>Cobrança</b>
          {{
            chargeOptions.find(
              (optionItem) => +optionItem.value === +item.tipoCobranca
            )?.text
          }}
        </PmwHeading>

        <!-- TIPO DE PERCENTUAL -->
        <PmwHeading
          size="paragraph-60"
          weight="weight-normal"
          class="form--item"
        >
          <b>Percentual</b>
          {{
            item.percentualPagamentoParcial
              ? `${item.percentualPagamentoParcial}%`
              : 'N/A'
          }}
        </PmwHeading>

        <!-- TIPO DE POLÍTICA DE REEMBOLSO -->
        <PmwHeading
          size="paragraph-60"
          weight="weight-normal"
          class="form--item"
        >
          <b>Política de reembolso</b>
          {{
            refundOptions.find(
              (optionItem) => +optionItem.value === +item.tipoPoliticaReembolso
            )?.text
          }}
        </PmwHeading>

        <!-- TEMPO DE LIMITE PARA REEMBOLSO -->
        <PmwHeading
          size="paragraph-60"
          weight="weight-normal"
          class="form--item"
        >
          <b>Limite para reembolso</b>
          {{ item.prazoCancelamentoGratuito ?? 'N/A' }}
        </PmwHeading>
      </div>
    </div>

    <PmwAlertModal v-model="showAlertModal" :text="alertModalText">
      <template #actions>
        <PmwButton
          size="large"
          variation="blue-100"
          @click="showAlertModal = false"
          >Fechar</PmwButton
        >
      </template>
    </PmwAlertModal>
  </div>
</template>

<script>
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'

export default {
  name: 'ModalityInputs',
  components: {
    PmwFormInput,
    PmwFormSelect,
    PmwButton,
    PmwHeading,
    PmwAlertModal
  },

  props: {
    fluctuationData: Object,

    hidePrePayment: Boolean
  },

  data() {
    return {
      showRefundError: false,

      /** Tipo de pagamento selecionado */
      paymentType: null,

      /** Tipo de cobrança */
      chargeType: null,

      percentage: null,

      /** Politica de reembolso */
      refund: null,

      refundTimeLimit: null,
      /**
       * Opções de tipo de pagamento
       * TIPOPAGAMENTO [1-GARANTIA; 2-PRÉ-PAGO; 3-SEM PAGAMENTO]
       */
      paymentOptions: [
        {
          text: 'Garantia',
          value: 1
        },
        {
          text: 'Pré-pagamento',
          value: 2
        },
        {
          text: 'Sem pagamento',
          value: 3
        }
      ],

      /**
       * Opções de cobrança
       * TIPOCOBRANCA [1-SEM COBRANÇA; 2-1ª DIAÁRIA; 3-INTEGRAL; 4-PARCIAL]
       */
      chargeOptions: [
        { text: 'Primeira Diária', value: 2 },
        { text: 'Integral', value: 3 },
        { text: 'Parcial', value: 4 }
      ],

      /**
       * Opções de tipos de reembolso
       * TIPOPOLITICA_REEMBOLSO [1-REEMBOLSÁBEL; 2-NÃO REEMBOLSÁBEL]
       * */
      refundOptions: [
        { text: 'Reembolsável', value: 1 },
        { text: 'Não reembolsável', value: 2 }
      ],

      /** Texto usado no modal de alerta */
      alertModalText: '',

      showAlertModal: false
    }
  },

  computed: {
    /** Desabilita o campo de cobrança */
    disableCharge() {
      return [1, 3].includes(this.paymentType?.value)
    },

    /** Desabilita o campo de politica de reembolso */
    disableRefund() {
      return [1, 3].includes(this.paymentType?.value)
    },

    /** Desabilita a porcentagem */
    disablePercentage() {
      return !(
        [2].includes(this.paymentType?.value) && +this.chargeType?.value === 4
      )
    },

    /** Desabilita o tempo de reembolso */
    disableRefundLimit() {
      return [3].includes(this.paymentType?.value) || +this.refund?.value === 2
    },

    /** Retorna as opções que não foram selecionadas */
    paymentOptionsFiltered() {
      if (!this.fluctuationData.meiosPagamento?.length) {
        if (this.hidePrePayment)
          return this.paymentOptions.filter((item) => item.value !== 2)

        return this.paymentOptions
      }

      if (this.hidePrePayment) {
        return this.paymentOptions.filter(
          (payOption) =>
            payOption.value !== 2 &&
            this.fluctuationData.meiosPagamento.findIndex(
              (item) => +item.tipoPagamento === +payOption.value
            ) < 0
        )
      }

      return this.paymentOptions.filter(
        (payOption) =>
          this.fluctuationData.meiosPagamento.findIndex(
            (item) => +item.tipoPagamento === +payOption.value
          ) < 0
      )
    },

    /** Desabilita o botão de adicionar */
    disableAddButton() {
      switch (true) {
        case !this.paymentType:
          return true
        case this.refundTimeLimit?.toString().length < 1 ||
          this.refundTimeLimit?.toString().length > 4:
          return true
        case this.refund?.value === 1 &&
          (!this.refundTimeLimit || this.refundTimeLimit < 1):
          return true
        case +this.paymentType?.value === 2:
          if (!this.chargeType || !this.refund) return true
          switch (+this.chargeType?.value) {
            case 4:
              if (!this.percentage) return true
              break
            default:
              break
          }
          break
        default:
          return false
      }

      return false
    }
  },

  watch: {
    refundTimeLimit(newVal) {
      if (newVal?.toString().length < 1) {
        this.showRefundError = true
        this.$bus.$emit('show-alert-chip', {
          message: 'O limite para reembolso deve conter no mínimo 1 hora.'
        })
        return null
      } else if (newVal?.toString().length > 4) {
        this.showRefundError = true
        this.$bus.$emit('show-alert-chip', {
          message: 'O limite para reembolso não deve conter mais que 4 digitos.'
        })
        return null
      } else {
        this.showRefundError = false
      }
    },

    paymentType(newValue) {
      const { value } = newValue ?? {}

      switch (value) {
        /** Garantia */
        case 1:
          this.chargeType = this.chargeOptions[0]
          this.refund = this.refundOptions[0]
          break

        case 2:
          break

        case 3:
          this.chargeType = null
          this.refund = null
          this.refundTimeLimit = null
          this.percentage = null
          break
      }
    }
  },

  methods: {
    addChargeTypeHandler() {
      if (this.fluctuationData.meiosPagamento?.length) {
        this.alertModalText = this.validateSelectedChargeTypes()

        if (this.alertModalText) {
          this.showAlertModal = true
          return
        }
      }

      /** Se for null adiciona um array vazio */
      if (!this.fluctuationData.meiosPagamento)
        this.fluctuationData.meiosPagamento = []

      this.fluctuationData.meiosPagamento.push({
        tipoPagamento: this.paymentType.value,
        tipoCobranca: this.chargeType?.value,
        tipoPoliticaReembolso: this.refund?.value,
        prazoCancelamentoGratuito: this.refundTimeLimit,
        percentualPagamentoParcial: this.percentage
      })

      this.paymentType = null
      this.chargeType = null
      this.refund = null
      this.refundTimeLimit = null
      this.percentage = null
    },

    validateSelectedChargeTypes() {
      // Sem pagamento só pode ser sozinha
      if (
        +this.paymentType.value === 3 ||
        this.fluctuationData.meiosPagamento.find(
          (item) => +item.tipoPagamento === 3
        )
      ) {
        return 'A opção Sem pagamento não pode ser usada com outros meios de pagamento!'
      }

      // Todos os meios reembolsaveis devem ter o mesmo limite de horas
      const refundable = this.fluctuationData.meiosPagamento.find(
        (item) => +item.tipoPoliticaReembolso === 1
      )

      if (refundable && +this.refund.value === 1) {
        const { prazoCancelamentoGratuito } = refundable

        if (+prazoCancelamentoGratuito !== +this.refundTimeLimit) {
          return 'Todos os meios de pagamento reembolsáveis devem ter o mesmo limite de horas!'
        }
      }
    },

    /**
     * Deleta um tipo de pagamento
     * @param {number} tipoPagamentoCode codigo do tipo de pagamento
     */
    deleteChargeType(tipoPagamentoCode) {
      const idx = this.fluctuationData.meiosPagamento.findIndex(
        (item) => +item.tipoPagamento === +tipoPagamentoCode
      )

      if (idx > -1) {
        this.fluctuationData.meiosPagamento.splice(idx, 1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modality {
  &-results {
    border: 1px solid pmw-colors(grey-20);
    padding: 12px 21px;
    margin-top: 25px;
  }

  &-inputs {
    border: 1px solid pmw-colors(grey-20);
    padding: 12px 21px;
  }
}

.remove-col {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  margin-bottom: 12px;

  &--btn {
    @include reset-button();

    .icon {
      width: 12px;
      height: 12px;
      color: $gray-dark;
      transition: color 0.8s;

      &:hover {
        color: red;
      }
    }
  }
}
.form {
  &--button {
    width: 100px;
  }

  &--item {
    font-size: font-size('size-medium');

    b {
      font-weight: font-weight('weight-medium');
    }
  }

  &--title {
    font-size: font-size('size-medium');
    font-weight: font-weight('weight-normal');
    line-height: 21px;

    &__bold {
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-medium');
      line-height: 21px;
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 18px;

    &__margin {
      margin-bottom: 0px;
      margin-top: 8px;
      gap: 32px;
    }

    &__nowrap {
      flex-wrap: nowrap;
    }
  }

  &--input {
    &-select {
      ::v-deep {
        .pmw-select--button__caret-sort-up,
        .pmw-select--button__show {
          border-bottom-color: pmw-colors('blue-100');
        }
        .pmw-select--button:focus {
          border-color: pmw-colors('blue-100');
          border-bottom-color: pmw-colors('blue-100');
        }
        .pmw-select-options--item__hover:hover,
        .pmw-select-options--item__checked {
          background-color: pmw-colors('blue-100') !important;
        }

        .pmw-label {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
      }
    }

    &-normal {
      width: 145px;

      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }
    }

    &__large {
      width: 100%;
      min-width: 145px;
      max-width: 160px;
    }

    &__medium {
      width: 125px;
    }

    &__small {
      width: 95px;
    }
  }
}
</style>
